const datosDePrueba = [
    {
        error: 'error',
    },
]

export default datosDePrueba;